export const authExtractedMessages = {
  "auth.LoginPage.createAnAccount": "Create an account",
  "auth.LoginPage.forgotYourPassword": "Forgot your password?",
  "auth.LoginPage.newToCelsus": "New to Celsus?",
  "auth.LoginPage.password": "Password",
  "auth.LoginPage.returnToYourReadingLife": "Return to your reading life",
  "auth.LoginPage.signIn": "Sign in",
  "auth.LoginPage.username": "Username",
  "auth.LoginPage.weCouldnTSignYouIn": "We couldn't sign you in",
  "auth.LoginPage.welcomeBack": "Welcome back",
  "auth.LoginPage.welcomeBackSignInToReturnTo":
    "Welcome back. Sign in to return to your library and continue where you left off.",
  "auth.LoginPage.yourPassword": "Your password",
  "auth.LoginPage.yourUsername": "Your username",
  "auth.RegisterPage.350Characters": "3–50 characters",
  "auth.RegisterPage.alreadyHaveAnAccount": "Already have an account?",
  "auth.RegisterPage.beginWithTheBooksYouHaveThen":
    "Begin with the books you have, then shape a reading practice that feels like your own.",
  "auth.RegisterPage.chooseAUsername": "Choose a username",
  "auth.RegisterPage.confirmPassword": "Confirm password",
  "auth.RegisterPage.createAccount": "Create account",
  "auth.RegisterPage.createAPassword": "Create a password",
  "auth.RegisterPage.createYourCelsusAccount": "Create your Celsus account",
  "auth.RegisterPage.emailAddress": "Email address",
  "auth.RegisterPage.enterItOnceMore": "Enter it once more",
  "auth.RegisterPage.fullName": "Full name",
  "auth.RegisterPage.howShouldWeAddressYou": "How should we address you?",
  "auth.RegisterPage.optional": "Optional",
  "auth.RegisterPage.password": "Password",
  "auth.RegisterPage.readerExampleCom": "reader@example.com",
  "auth.RegisterPage.signIn": "Sign in",
  "auth.RegisterPage.username": "Username",
  "auth.RegisterPage.weCouldnTCreateYourAccount": "We couldn't create your account",
  "auth.RegisterPage.yourNextChapter": "Your next chapter",
} as const;
